import type { IconSvgObject } from './types';

const BingIcon: IconSvgObject = [
  ["path", { d: "M4 19.5V2L8 4V17L15 13L12 12L11 8L19.9981 10.5V15L8 22L4 19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default BingIcon;
